import theme from 'shared/themes/default';

export const ORGANIZATION = 'ORGANIZATION';
export const USER = 'USER';
export const GROUP = 'GROUP';
export const NONE = 'NONE';

export const shareTypeMapping = {
  GROUP,
  NONE,
  ORGANIZATION,
  USER,
} as const;

export const invitationStatus = {
  pending: 'PENDING',
  invited: 'INVITED',
  bounced: 'BOUNCED',
} as const;

export const invitationSource = {
  client: 'CLIENT',
  backoffice: 'BACKOFFICE',
  import: 'IMPORT',
} as const;

export const membersRoles = {
  admin: 'ADMIN',
  manager: 'MANAGER',
  member: 'MEMBER',
} as const;

export const actionsOnContentOwnership = {
  delete: 'DELETE',
  transfer: 'TRANSFER',
} as const;

export const backgroundTheme = [
  { name: 'videocation-light', value: theme.palette.lightPure },
  { name: 'videocation-dark', value: theme.palette.mainDark },
] as const;

export const BACKGROUND_THEMES = ['light', 'dark'] as const;

export const DOMAIN = ['no', 'es'] as const;

export const EXAM_TYPE = {
  NONE: 'none',
  TEST: 'test',
  GAME: 'game',
} as const;

export const EXAM_ATTEMPT_STATUS = {
  STARTED: 'STARTED',
  NOT_STARTED: 'NOT_STARTED',
  ATTEMPTS_EXCEEDED: 'ATTEMPTS_EXCEEDED',
} as const;

export const CERTIFICATE_STATUS = {
  FAILED: 'FAILED',
  PASSED: 'PASSED',
} as const;

export const PLAYLIST_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  PAUSED: 'PAUSED',
  TEMPLATE: 'TEMPLATE',
} as const;

export const PLAYLIST_ITEM_TYPE = {
  COURSE: 'COURSE',
  EPISODE: 'EPISODE',
  GAME: 'GAME',
  PLACEHOLDER: 'PLACEHOLDER',
  QUIZ: 'QUIZ',
  TRAILER: 'TRAILER',
} as const;

export const stripeLocaleMapping = {
  no: 'nb',
  es: 'es',
  en: 'en',
} as const;

export const AUTHENTICATION_FLOWS = {
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  LOGIN: 'LOGIN',
  PURCHASE: 'PURCHASE',
  REGISTER: 'REGISTER',
  NELFO: 'NELFO',
  VERIFY: 'VERIFY',
} as const;

export const PAYMENT_TYPE = {
  CARD: 'CARD',
  INVOICE: 'INVOICE',
} as const;

export const courseStatus = {
  ARCHIVED: 'ARCHIVED',
  DRAFT: 'DRAFT',
  HIDDEN: 'HIDDEN',
  PUBLISHED: 'PUBLISHED',
} as const;

export const courseType = {
  FREE: 'FREE',
  PREMIUM: 'PREMIUM',
  SELFPUBLISH: 'SELFPUBLISH',
} as const;

export const contentType = {
  VIDEO: 'video',
  GAME: 'game',
} as const;

export const TAB_STATUS = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  DISABLED: 'DISABLED',
} as const;

export const stripeSubscriptionStatus = {
  INCOMPLETE: 'incomplete',
  INCOMPLETE_EXPIRED: 'incomplete_expired',
  ACTIVE: 'active',
  PASTDUE: 'past_due',
  CANCELED: 'canceled',
  UNPAID: 'unpaid',
  PAUSED: 'paused',
  NOT_STARTED: 'not_started', // Custom status, not from Stripe
} as const;

export const SUBSCRIPTION_PLAN_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  GROUP: 'GROUP',
  CORPORATE: 'CORPORATE',
} as const;

export const PRODUCT_TYPE = {
  INDIVIDUAL: 'INDIVIDUAL',
  GROUP: 'GROUP',
} as const;

export const LOCALES = ['no', 'es', 'en'] as const;

// Default locale must be first
export const DOMAIN_LOCALES = {
  no: ['no', 'en'],
  es: ['es', 'en'],
} as const;

export const LANGUAGE_NAMES = {
  no: 'Norsk',
  en: 'English',
  es: 'Español',
} as const;

export const PLAYER_CONTENT_TYPE = {
  COURSE: 'COURSE',
  PLAYLIST: 'PLAYLIST',
  TRAILER: 'TRAILER',
} as const;

export const PLAYER_CONTENT_SUB_TYPE = {
  COURSE: 'COURSE',
  LESSON: 'LESSON',
  TRAILER: 'TRAILER',
} as const;

export const PLAYER_NEXT_CONTENT_TYPE = {
  COURSE: 'COURSE',
  GAME: 'GAME',
  LESSON: 'LESSON',
  SUBSCRIPTION: 'SUBSCRIPTION',
  TEST: 'TEST',
} as const;

export const PLAYER_TRANSITION_TYPE = {
  COURSE: 'COURSE',
  EMPTY: 'EMPTY',
  ERROR: 'ERROR',
  GAME: 'GAME',
  TEST: 'TEST',
} as const;

export const PLAYER_EVENTS = {
  CAN_PLAY_THROUGH: 'canplaythrough',
  CLICK: 'click',
  ENDED: 'ended',
  ERROR: 'error',
  FULLSCREEN_CHANGE: 'fullscreenchange',
  HIDE_CONTROLS: 'HIDE_CONTROLS',
  HIDE_TRANSITION: 'HIDE_TRANSITION',
  HIDE_UPNEXT: 'HIDE_UPNEXT',
  LOADED_METADATA: 'loadedmetadata',
  LOAD_START: 'loadstart',
  MOUSE_MOVE: 'mousemove',
  PLAY: 'play',
  PAUSE: 'pause',
  RESTART: 'restart',
  SEEKED: 'seeked',
  SEEKING: 'seeking',
  SHOW_CONTROLS: 'SHOW_CONTROLS',
  SHOW_TRANSITION: 'SHOW_TRANSITION',
  SHOW_UPNEXT: 'SHOW_UPNEXT',
  UPDATE_BANNER_TYPE: 'UPDATE_BANNER_TYPE',
  UPDATE_ERROR: 'UPDATE_ERROR',
  UPDATE_LOADING: 'UPDATE_LOADING',
  UPDATE_LOCALE: 'UPDATE_LOCALE',
  UPDATE_LOCKED: 'UPDATE_LOCKED',
  UPDATE_NEXT: 'UPDATE_NEXT',
  UPDATE_PREVIOUS: 'UPDATE_PREVIOUS',
  UPDATE_STRICT_INTEGRITY: 'UPDATE_STRICT_INTEGRITY',
  UPDATE_SUBTITLES: 'UPDATE_SUBTITLES',
  UPDATE_SUBTYPE: 'UPDATE_SUBTYPE',
  UPDATE_VIDEO_QUALITIES: 'UPDATE_VIDEO_QUALITIES',
  USER_ACTIVE: 'useractive',
  USER_INACTIVE: 'userinactive',
  TIME_UPDATE: 'timeupdate',
  CONTEXT_MENU: 'contextmenu',
} as const;

export const PLAYER_CALLBACKS = {
  RETRY: 'RETRY',
} as const;

export const PLAYER_DURATIONS = {
  CLOSE_CONTROLBAR: 500,
  OPEN_CONTROLBAR: 100,
  USER_INACTIVE: 2000,
} as const;

export const AUTOCOMPLETEWITHLIST_TYPE = {
  FORM: 'FORM',
} as const;

export const PROCESSING_STATUS = {
  TO_SCHEDULE: 'TO_SCHEDULE',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  ERROR: 'ERROR',
} as const;

export const PROCESSING_STATUS_PRIORITY = [
  PROCESSING_STATUS.PROCESSED,
  PROCESSING_STATUS.ERROR,
  PROCESSING_STATUS.PROCESSING,
  PROCESSING_STATUS.TO_SCHEDULE,
] as const;

export const COURSE_WATCH_TYPE = {
  COURSE: 'COURSE',
  EPISODE: 'EPISODE',
  QUIZ: 'QUIZ',
  GAME: 'GAME',
  TRAILER: 'TRAILER',
} as const;

export const PLAYER_LOCAL_STORAGE = {
  AUTOPLAY: 'videocation-player-autoplay',
  MUTED: 'videocation-player-muted',
  SPEED: 'videocation-player-speed',
  SUBTITLE: 'videocation-player-subtitle',
  VOLUME: 'videocation-player-volume',
  QUALITY: 'videocation-player-quality',
} as const;

export const COURSE_VIEW_TABS = {
  INFORMATION: 'information',
  ATTACHMENTS: 'attachments',
  LESSONS: 'lessons',
} as const;

export const BANNER_LOCKED_TYPE = {
  ORGANIZATION_ADMIN: 'ORGANIZATION_ADMIN',
  ORGANIZATION_CUSTOM: 'ORGANIZATION_CUSTOM',
  ORGANIZATION_USER: 'ORGANIZATION_USER',
  ORGANIZATION_LOCKED_USER: 'ORGANIZATION_LOCKED_USER',
  SINGLE_SUBSCRIBER: 'SINGLE_SUBSCRIBER',
} as const;

export const MAX_COURSE = {
  DESCRIPTION_LENGTH: 6000,
  NAME_LENGTH: 70,
  PREREQUISITES_TYPICAL_LENGTH: 200,
  SHORT_DESCRIPTION_LENGTH: 300,
} as const;

export const MAX_PLAYLIST = {
  DESCRIPTION_LENGTH: 500,
  NAME_LENGTH: 70,
} as const;

export const TIMESTAMP_FORMATS = {
  DATE: 'DATE',
  DATE_DEFAULT: 'DATE_DEFAULT',
  DATE_TIME: 'DATE_TIME',
  MONTH: 'MONTH',
  MONTH_YEAR: 'MONTH_YEAR',
  TIME: 'TIME',
} as const;

export const CATEGORY_TYPE = {
  CATEGORY: 'category',
  PLAYLIST: 'playlist',
} as const;

export const SOCIAL_TYPE = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  YOUTUBE: 'youtube',
  LINKEDIN: 'linkedin',
  SNAPCHAT: 'snapchat',
} as const;

export const COURSE_LEVELS = {
  FOUNDATIONAL: 'foundational',
  INTEMEDIATE: 'intermediate',
  ADVANCED: 'advanced',
} as const;

export const EPISODE_TYPE = {
  VIDEO: 'video',
  GAME: 'game',
} as const;

export const EPISODE_STATUS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  DRAFT: 'draft',
} as const;

export const GAME_TYPE = {
  GAME: 'game',
  ROLEPLAY: 'roleplay',
} as const;

export const ORGANIZATION_TYPE = {
  TEAM: 'TEAM',
  ENTERPRISE: 'ENTERPRISE',
} as const;

export const USER_CHANGE_CONTENT_TYPE = {
  DELETE: 'DELETE',
  TRANSFER: 'TRANSFER',
} as const;

export const SUBSCRIPTION_PLAN_STATUS = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  INVOICE: 'INVOICE',
} as const;

export const CONTENT_TYPE = {
  SKELETON: 'SKELETON',
  GAME: 'GAME',
  PLAYER: 'PLAYER',
  QUIZ: 'QUIZ',
  LOADING: 'LOADING',
} as const;

type ValueOf<T> = T[keyof T];

export type ShareTypeMapping = ValueOf<typeof shareTypeMapping>;
export type InvitationStatus = ValueOf<typeof invitationStatus>;
export type InvitationSource = ValueOf<typeof invitationSource>;
export type MembersRoles = ValueOf<typeof membersRoles>;
export type ActionsOnContentOwnership = ValueOf<
  typeof actionsOnContentOwnership
>;
export type BackgroundTheme = (typeof backgroundTheme)[number];
export type BackgroundThemes = (typeof BACKGROUND_THEMES)[number];
export type Domain = (typeof DOMAIN)[number];
export type ExamType = ValueOf<typeof EXAM_TYPE>;
export type ExamAttemptStatus = ValueOf<typeof EXAM_ATTEMPT_STATUS>;
export type CertificateStatus = ValueOf<typeof CERTIFICATE_STATUS>;
export type PlaylistStatus = ValueOf<typeof PLAYLIST_STATUS>;
export type PlaylistItemType = ValueOf<typeof PLAYLIST_ITEM_TYPE>;
export type StripeLocaleMapping = ValueOf<typeof stripeLocaleMapping>;
export type AuthenticationFlows = ValueOf<typeof AUTHENTICATION_FLOWS>;
export type PaymentType = ValueOf<typeof PAYMENT_TYPE>;
export type CourseStatus = ValueOf<typeof courseStatus>;
export type CourseType = ValueOf<typeof courseType>;
export type ContentType = ValueOf<typeof contentType>;
export type TabStatus = ValueOf<typeof TAB_STATUS>;
export type StripeSubscriptionStatus = ValueOf<typeof stripeSubscriptionStatus>;
export type SubscriptionPlanTypes = ValueOf<typeof SUBSCRIPTION_PLAN_TYPES>;
export type ProductType = ValueOf<typeof PRODUCT_TYPE>;
export type Locales = (typeof LOCALES)[number];
export type DomainLocales = typeof DOMAIN_LOCALES;
export type LanguageNames = typeof LANGUAGE_NAMES;
export type PlayerContentType = ValueOf<typeof PLAYER_CONTENT_TYPE>;
export type PlayerContentSubType = ValueOf<typeof PLAYER_CONTENT_SUB_TYPE>;
export type PlayerNextContentType = ValueOf<typeof PLAYER_NEXT_CONTENT_TYPE>;
export type PlayerTransitionType = ValueOf<typeof PLAYER_TRANSITION_TYPE>;
export type PlayerEvents = ValueOf<typeof PLAYER_EVENTS>;
export type PlayerCallbacks = ValueOf<typeof PLAYER_CALLBACKS>;
export type PlayerDurations = typeof PLAYER_DURATIONS;
export type AutocompleteWithListType = ValueOf<
  typeof AUTOCOMPLETEWITHLIST_TYPE
>;
export type ProcessingStatus = ValueOf<typeof PROCESSING_STATUS>;
export type ProcessingStatusPriority =
  (typeof PROCESSING_STATUS_PRIORITY)[number];
export type CourseWatchType = ValueOf<typeof COURSE_WATCH_TYPE>;
export type PlayerLocalStorage = typeof PLAYER_LOCAL_STORAGE;
export type CourseViewTabs = ValueOf<typeof COURSE_VIEW_TABS>;
export type BannerLockedType = ValueOf<typeof BANNER_LOCKED_TYPE>;
export type MaxCourse = typeof MAX_COURSE;
export type MaxPlaylist = typeof MAX_PLAYLIST;
export type TimestampFormats = ValueOf<typeof TIMESTAMP_FORMATS>;
export type CategoryType = ValueOf<typeof CATEGORY_TYPE>;
export type SocialType = ValueOf<typeof SOCIAL_TYPE>;
export type CourseLevels = ValueOf<typeof COURSE_LEVELS>;
export type EpisodeType = ValueOf<typeof EPISODE_TYPE>;
export type EpisodeStatus = ValueOf<typeof EPISODE_STATUS>;
export type GameType = ValueOf<typeof GAME_TYPE>;
export type OrganizationType = ValueOf<typeof ORGANIZATION_TYPE>;
export type UserChangeContentType = ValueOf<typeof USER_CHANGE_CONTENT_TYPE>;
export type SubscriptionPlanStatus = ValueOf<typeof SUBSCRIPTION_PLAN_STATUS>;
export type ContentTypeEnum = ValueOf<typeof CONTENT_TYPE>;
